
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.below-menu{margin-block-start:var(--spacing-0)}.footer-container.large{align-self:flex-end;padding-bottom:var(--spacing-24);width:85%}.large .below-menu,.medium .below-menu{align-items:flex-start}.large .below-menu{gap:var(--spacing-64)}.copyright-terms{margin-block-start:var(--spacing-0)}.note{margin-block-start:var(--spacing-2)}.phone strong{font-size:var(--fs-lg)}`;